/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FieldPlacement } from './FieldPlacement';
import {
    FieldPlacementFromJSON,
    FieldPlacementFromJSONTyped,
    FieldPlacementToJSON,
    FieldPlacementToJSONTyped,
} from './FieldPlacement';

/**
 * 
 * @export
 * @interface UpdateFieldPlacementsRequest
 */
export interface UpdateFieldPlacementsRequest {
    /**
     * Updated field placement configuration. At most 20 of these may have type=signature — matches the 20-item cap on SubmitFormDocumentRequest's signaturePlacements, so a template can never define more required signature fields than a homeowner submission is able to satisfy.
     * @type {Array<FieldPlacement>}
     * @memberof UpdateFieldPlacementsRequest
     */
    fieldPlacements: Array<FieldPlacement>;
}

/**
 * Check if a given object implements the UpdateFieldPlacementsRequest interface.
 */
export function instanceOfUpdateFieldPlacementsRequest(value: object): value is UpdateFieldPlacementsRequest {
    if (!('fieldPlacements' in value) || value['fieldPlacements'] === undefined) return false;
    return true;
}

export function UpdateFieldPlacementsRequestFromJSON(json: any): UpdateFieldPlacementsRequest {
    return UpdateFieldPlacementsRequestFromJSONTyped(json, false);
}

export function UpdateFieldPlacementsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateFieldPlacementsRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'fieldPlacements': ((json['fieldPlacements'] as Array<any>).map(FieldPlacementFromJSON)),
    };
}

export function UpdateFieldPlacementsRequestToJSON(json: any): UpdateFieldPlacementsRequest {
    return UpdateFieldPlacementsRequestToJSONTyped(json, false);
}

export function UpdateFieldPlacementsRequestToJSONTyped(value?: UpdateFieldPlacementsRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'fieldPlacements': ((value['fieldPlacements'] as Array<any>).map(FieldPlacementToJSON)),
    };
}

